export const breakPoints = [
    {
        name: 'xl',
        min: 1200,
        max: Infinity,
    },
    {
        name: 'lg',
        min: 1025,
        max: 1199,
    },
    {
        name: 'md',
        min: 768,
        max: 1024,
    },
    {
        name: 'sm',
        min: 480,
        max: 767,
    },
    {
        name: 'xs',
        min: 0,
        max: 479,
    },
];

export const getBreakpoint = () => {
    if (typeof document === 'undefined') {
        return 'lg';
    }
    const currentWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    for (const breakpoint of breakPoints) {
        if (currentWidth >= breakpoint.min && currentWidth <= breakpoint.max) {
            return breakpoint.name;
        }
    }
};

const breakpointCompare = (a, b, operator) => {
    let i1 = 0;
    let i2 = breakPoints.length;
    for (let i = 0; i < breakPoints.length; i++) {
        if (breakPoints[i].name === a) {
            i1 = i;
            break;
        }
    }
    for (let i = 0; i < breakPoints.length; i++) {
        if (breakPoints[i].name === b) {
            i2 = i;
            break;
        }
    }
    if (operator === '>') {
        return i1 > i2;
    }
    return i1 < i2;
};

export const breakpointLessThan = (breakpoint, current) => breakpointCompare(breakpoint, current, '<');
